import { Typography } from 'antd';
import isEmpty from 'lodash/isEmpty';
import PropTypes from 'prop-types';
import React from 'react';

const { Text } = Typography;

const OfficeEmails = ({ value }) => {
  if (isEmpty(value)) return '-';
  
  const emails = value?.filter(e => !!e);
  return (
    <div>
      {emails.map(email => (
        <div key={email} className="flex flex-wrap">
          <Text className="font-normal">{email}</Text>
        </div>))
      }
    </div>
  );
};

export default OfficeEmails;

OfficeEmails.propTypes = {
  value: PropTypes.array,
};

export const renderOfficeEmails = (array) => {
  return <OfficeEmails value={array}/>;
};
